"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARROW_RIGHT_KEY = exports.ARROW_LEFT_KEY = exports.ARROW_DOWN_KEY = exports.ARROW_UP_KEY = exports.SPACE_KEY = exports.ENTER_KEY = exports.TAB_KEY = exports.ESC_KEY = void 0;
exports.ESC_KEY = 27;
exports.TAB_KEY = 9;
exports.ENTER_KEY = 13;
exports.SPACE_KEY = 32;
exports.ARROW_UP_KEY = 38;
exports.ARROW_DOWN_KEY = 40;
exports.ARROW_LEFT_KEY = 37;
exports.ARROW_RIGHT_KEY = 39;
//# sourceMappingURL=key-codes.js.map